export class PhotoService {
  static $inject = ['PhotoModalService'];

  // constructor(private photoModalService: PhotoModalService: any){}
  constructor(private PhotoModalService: any) {}

  openAddPhotosModal(apiUrl, items, successCallback) {
    this.PhotoModalService.openAddPhotosModal(apiUrl, items, successCallback);
  }
}
